import { useAppSelector } from '../../app/typedReduxHooks'
import { useFeatureToggle } from '../../common/utils/feature-toggle/useFeatureToggle'
import { FEATURES } from '../../common/utils/feature-toggle/features'
import { FeatureKey, PlanEntitlements } from '../../types/organization-entitlements'

const FEATURE_TOGGLE_KEYS: Partial<Record<FeatureKey, keyof typeof FEATURES>> = {
  [FeatureKey.SHARED_PATIENTS]: 'SHARED_PATIENTS',
}

const useOrganizationEntitlements = () => {
  return useAppSelector((state) => state.organization.entitlements?.entitlements)
}

const useIsFeatureToggleEnabled = (featureKey: FeatureKey): boolean => {
  const toggleKey = FEATURE_TOGGLE_KEYS[featureKey]

  if (!toggleKey) {
    return true
  }

  const { isFeatureEnabled } = useFeatureToggle(toggleKey)
  return isFeatureEnabled
}

export const useEntitlementValue = <T extends FeatureKey>(
  featureKey: T
): PlanEntitlements[T] | undefined => {
  const entitlements = useOrganizationEntitlements()
  const isToggleEnabled = useIsFeatureToggleEnabled(featureKey)

  if (!isToggleEnabled) {
    return undefined
  }

  return entitlements?.[featureKey]
}

export const useHasEntitlement = (featureKey: FeatureKey): boolean => {
  const entitlementValue = useEntitlementValue(featureKey)

  if (typeof entitlementValue === 'boolean') {
    return entitlementValue
  }

  if (typeof entitlementValue === 'number') {
    return entitlementValue > 0
  }

  return false
}
